<template>
  <BaseTableWrapper :no-body="Boolean(messageRecipientUserDataContractorFilter)">
    <template #filtering>
      <div class="text-right">
        <b-button aria-controls="message_to_approve_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.message_to_approve_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="message_to_approve_search_collapse" class="mt-2">
          <MessageFiltering :messageRecipientUserDataContractorFilter="messageRecipientUserDataContractorFilter" @getPage="getPage($event)"></MessageFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <b-row>
        <b-col>
          <div v-if="isLoading">
            <Loader></Loader>
          </div>
          <div v-else-if="!isLoading && items.length < 1">
            {{ $t('views.excmmessages.list.noMessages') }}
          </div>
          <div v-else>
            <table class="table table-sm table-responsive-md table-striped table-hover">
              <thead>
              <tr>
                <th class="text-center"></th>
                <th>{{ $t('views.excmmessages.list.messageType') }}</th>
                <th>{{ $t('views.excmmessages.list.createdAt') }}</th>
                <th>{{ $t('views.excmmessages.list.plannedSending') }}</th>
                <th>{{ $t('views.excmmessages.list.sender') }}</th>
                <th>{{ $t('views.excmmessages.list.recipient') }}</th>
                <th>{{ $t('views.excmmessages.list.recipientCc') }}</th>
                <th>{{ $t('views.excmmessages.list.subject') }}</th>
                <th>{{ $t('views.excmmessages.list.content') }}</th>
                <th>{{ $t('views.excmmessages.list.status') }}</th>
                <th>{{ $t('views.excmmessages.list.sentStatus') }}</th>
                <th colspan="2" />
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in items" :key="item['@id']">
                <td class="text-center">
                  <b-form-checkbox
                    v-model="selectedMessages"
                    :value="item"
                  ></b-form-checkbox>
                </td>
                <td>
                  <i v-if="item.messageType === 1" class="ml-2 fa fa-envelope fa-lg"></i>
                  <i v-if="item.messageType === 2" class="ml-2 fa fa-sms fa-lg"></i>
                </td>
                <td>
                  {{ $moment(item['createdAt']).format('YYYY-MM-DD HH:mm:ss') }}
                </td>
                <td>
                  {{ $moment(item['plannedSending']).format('YYYY-MM-DD HH:mm:ss') }}
                </td>
                <td>
                  {{ item.sender }}
                </td>
                <td>
                  <div v-html="item.recipient.replace(/,/g, '<br>')"></div>
                  <p class="p-0 m-0" v-for="(userRecipient, userRecipientIndex) in item.recipientsUserData" :key="'userRecipientToApproveIndex' + userRecipientIndex">
                    <router-link v-if="userRecipient.isCompany === 0" :to="{name: 'UserDataShow', params: { id: userRecipient['@id'] }}">
                      {{ userRecipient.name }} {{ userRecipient.surname }}
                    </router-link>
                    <router-link v-else :to="{name: 'FirmShow', params: { id: userRecipient['@id'] }}">
                      {{ userRecipient.firmname1 === '' ? userRecipient.fullName : userRecipient.firmname1 }}
                    </router-link>
                  </p>
                </td>
                <td>
                  <div v-html="item.recipientCc.replace(/,/g, '<br>')"></div>
                </td>
                <td>
                  {{ item.subject }}
                </td>
                <td>
                  <span v-if="item.messageType === 1" class="text-primary" @click="showModal(item)" style="cursor: pointer">{{$t('buttons.preview')}}</span>
                  <span v-if="item.messageType === 2 && item.contentSms">{{ item.contentSms.contentSms }}</span>
                </td>
                <td>
                  {{ item.sent }}
                </td>
                <td>
                  {{ item.sentStatus }}
                </td>
                <td>
                  <b-dropdown variant="link" size="sm" right text="Right align">
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item @click="approveMessage(item['@id'])"><i class="fa fa-check"></i> {{$t('buttons.approveMessage')}}</b-dropdown-item>
                    <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div v-if="view">
            <pagination
              :view="view"
              @getPage="getPage($event)"
            ></pagination>
          </div>
          <p>{{$t('views.exsbsettlements.show.selectedPositionsQuantity')}}: <b>{{ selectedMessages.length }}</b></p>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="selectAll()"> {{ $t('buttons.selectAll') }} </button>
          <button type="button" class="btn btn-sm btn-warning float-left" @click="unSelectAll()"> {{ $t('buttons.unSelectAll') }} </button>
          <b-dropdown size="sm" variant="warning" dropright text="Drop-Right">
            <template #button-content>
              {{ $t('buttons.collectionOperations') }}
            </template>
            <b-dropdown-item @click="approveSelectedMessages"><i class="fa fa-file-check mr-2"></i>{{$t('buttons.approveSelectedMessages')}}</b-dropdown-item>
            <b-dropdown-item @click="deleteSelectedMessages"><i class="fa fa-trash mr-2"></i>{{$t('buttons.deleteSelectedMessages')}}</b-dropdown-item>
          </b-dropdown>
        </b-col>
      </b-row>
      <b-modal ref="modalContentMailToApprove" hide-footer size="lg" centered>
        <div v-html="modalContent.html">
        </div>
        <div v-if="modalContent.attachments.length > 0">
          <hr>
          <p><b>{{$t('views.messages.index.attachments')}}:</b></p>
          <p v-for="attachment in modalContent.attachments" v-bind:key="attachment.id">{{attachment.fileName}}</p>
          <p v-if="modalContent.attachments.length == 0">{{$t('views.messages.index.noAttachments')}}</p>
        </div>
      </b-modal>
    </template>
  </BaseTableWrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'

import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import MessageFiltering from '@/components/Dashboard/Views/excmmessage/components/MessageFiltering'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import remove from '@/utils/remove'
import ApiService from '@/utils/ApiService'
import getId from '@/utils/getIdFromLink'

export default {
  name: 'MessagesToApproveList',
  components: {
    Loader,
    Pagination,
    BaseTableWrapper,
    MessageFiltering
  },

  props: {
    messageRecipientUserDataContractorFilter: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      selectedMessages: [],
      modalContent: {
        html: '',
        attachments: []
      }
    }
  },

  computed: mapGetters({
    deletedItem: 'excmmessage/del/deleted',
    error: 'excmmessage/listtoapprove/error',
    items: 'excmmessage/listtoapprove/items',
    isLoading: 'excmmessage/listtoapprove/isLoading',
    view: 'excmmessage/listtoapprove/view'
  }),

  beforeCreate () {
    checkPagePermission('configuration', 'EXCMMessageList')
  },

  created () {
    this.getList()
    this.channelMessage = this.$store.state.Pusher.subscribe('e_x_s_b_messages')
    this.channelMessage.bind('e_x_s_b_messages', data => {
      this.getList()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_messages')
  },

  methods: {
    getList () {
      this.getPage()
    },
    selectAll () {
      let selectAll = []
      for (let i in this.items) {
        selectAll.push(this.items[i])
      }
      this.selectedMessages = selectAll
    },
    unSelectAll () {
      this.selectedMessages = []
    },
    deleteSelectedMessages () {
      let selections = []
      for (let i in this.selectedMessages) {
        selections.push(this.getIdLink(this.selectedMessages[i]['@id']))
      }
      let params = {
        selections: selections
      }
      remove('e_x_c_m_messagesdelete',
        () => {
          this.getList()
          this.unSelectAll()
        },
        () => {},
        params)
    },
    deleteSingle (id) {
      remove(id, () => {
        this.getList()
      })
    },
    approveSelectedMessages () {
      this.$Swal({
        title: this.$t('notifications.message.approveSelectedMessagesTitle'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(async () => {
        let selections = []
        for (let i in this.selectedMessages) {
          selections.push(this.getIdLink(this.selectedMessages[i]['@id']))
        }
        let params = {
          selections: selections
        }
        let response = await new ApiService(`e_x_c_m_messages/approveselectedmessages`).post(params)
        if (response) {
          this.getList()
          this.unSelectAll()
        }
      })
    },
    approveMessage (id) {
      this.$Swal({
        title: this.$t('notifications.message.approveMessageTitle'),
        text: this.$t('notifications.deleteDescription'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      }).then(async () => {
        let response = await new ApiService(id + `/approve`).put({ id: id })
        if (response) {
          this.getPage(this.view['@id'])
        }
      })
    },
    showModal (mail) {
      this.modalContent.html = ''
      if (mail.contentEmail) {
        this.modalContent.html = mail.contentEmail
      } else if (mail.messageContentEmail && mail.messageContentEmail.contentEmail) {
        this.modalContent.html = mail.messageContentEmail.contentEmail
      }
      this.$refs.modalContentMailToApprove.show()
    },
    getIdLink (link) {
      return getId(link)
    },
    ...mapActions({
      getPage: 'excmmessage/listtoapprove/getItems'
    })
  }
}
</script>
